import { Action }  from '@ngrx/store';
import { type } from "./utils/util";
import { CustomAction } from "./utils/action";

const initialState = { authenticated: false }

export interface AuthState {
    authenticated: boolean
    token?: string
    id?: number
}

const ActionTypes = {
    UPDATE: type("AUTH_UPDATE"),
    REMOVE: type("AUTH_REMOVE")
}

export class UpdateAuth implements Action {
    type = ActionTypes.UPDATE
    payload: AuthState

    constructor(args: AuthState) {
        this.payload = args
    }
}

export class RemoveAuth implements Action {
    type = ActionTypes.REMOVE

    constructor() {}
}

export function AuthReducer(state: AuthState = initialState, action: CustomAction) {
    switch (action.type) {
        case ActionTypes.UPDATE:
            return Object.assign({}, state, action.payload)
        case ActionTypes.REMOVE:
            return initialState
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/states/auth.reducer.ts